module.exports = __webpack_public_path__ + "static/media/TShirt.0c05e082.jpg";